import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { TabForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const CreateView = (props: any) => {
    const { onFinish, onFinishFailed, order } = props;

    return (
        <Layout
            titles={[
                { name: "Tabs", link: "/tab" },
                { name: "New", link: "" },
            ]}
        >
            <MetaTag title="Add Tab" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Tab Create"}
                        bordered={true}
                    >
                        <TabForm
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            order={order}
                        />
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default CreateView;
